import { render, staticRenderFns } from "./general.vue?vue&type=template&id=61739aa8&scoped=true"
import script from "./general.vue?vue&type=script&lang=js"
export * from "./general.vue?vue&type=script&lang=js"
import style0 from "./general.vue?vue&type=style&index=0&id=61739aa8&prod&scoped=true&lang=css"
import style1 from "./general.vue?vue&type=style&index=1&id=61739aa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61739aa8",
  null
  
)

export default component.exports